import UploadIcon from '../../common/icons/UploadIcon'
import TextFieldsIcon from '../../common/icons/TextFieldsIcon'
import LayersIcon from '../../common/icons/LayersIcon'
import ShapesIcon from '../../common/icons/ShapesIcon'

export const SIDEBAR_ITEM_IDS = {
    ADD_IMAGE: 'addImage',
    ADD_TEXT: 'addText',
    LAYERS: 'layers',
    SHAPES: 'shapes',
    DEVTOOLS: 'devtools',
}

export const sidebarConfig = [
    {
        id: SIDEBAR_ITEM_IDS.ADD_IMAGE,
        action: 'addImage',
        label: 'Add image',
        icon: UploadIcon,
        panelId: null,
    },
    {
        id: SIDEBAR_ITEM_IDS.ADD_TEXT,
        action: 'addText',
        label: 'Add text',
        icon: TextFieldsIcon,
        panelId: null,
    },
    {
        id: SIDEBAR_ITEM_IDS.LAYERS,
        action: 'togglePanel',
        label: 'Layers',
        icon: LayersIcon,
        panelId: 'layers',
    },
    {
        id: SIDEBAR_ITEM_IDS.SHAPES,
        action: 'togglePanel',
        label: 'Shapes',
        icon: ShapesIcon,
        panelId: 'shapes',
    },
    {
        id: SIDEBAR_ITEM_IDS.DEVTOOLS,
        action: 'togglePanel',
        label: 'DevTools',
        icon: null,
        panelId: 'devtools',
        visibleWhen: 'devTools',
    },
]
